import React from "react";
import DealsTable from "../Table/DealTable";

const DealsList = (check) => {
  return <DealsTable check={check} />;
};

export default DealsList;
